export const products = [
  {
    id: "osusume-5000",
    name: "おすすめパック",
    price: 5000,
    priceLabel: "5,000円（税込）",
    weight: "約1kg",
    description:
      "その時におすすめのお肉を組み合わせたおすすめパック。内容は時期や在庫によって変わる場合があります。",
    category: "おすすめ",
    imageKey: "product1",
  },
  {
    id: "osusume-10000",
    name: "おすすめパック",
    price: 10000,
    priceLabel: "10,000円（税込）",
    weight: "約2〜3kg",
    description:
      "その時におすすめのお肉を組み合わせたおすすめパック。内容は時期や在庫によって変わる場合があります。",
    category: "おすすめ",
    imageKey: "product2",
  },
  {
    id: "pet-inoshishi",
    name: "ペット用猪セット",
    price: 3000,
    priceLabel: "3,000円（税込）",
    weight: "肉3kg＋骨2kg＝合計約5kg",
    description: "ペット用の猪セット。骨はおまけとして付けています。",
    note: "骨の在庫がない場合は、お肉3キロのみ、もしくは、内臓などに変更になる場合がございます。",
    category: "ペット用",
    imageKey: "product3",
  },
  {
    id: "pet-shika",
    name: "鹿肉ペット用セット",
    price: 3000,
    priceLabel: "3,000円（税込）",
    weight: "肉3kg＋骨2kg",
    description: "ペット用の鹿肉セット。骨はおまけとして付けています。",
    note: "骨の在庫がない場合は、お肉3キロのみ、もしくは内臓などに変更になる場合がございます。",
    category: "ペット用",
    imageKey: "product4",
    soldOut: true,
  },
];